export function resizeCanvas(canvas, width, height) {
  var ctx = canvas.getContext("2d");
  var devicePixelRatio = window.devicePixelRatio || 1;
  canvas.width = Math.floor(width * devicePixelRatio); // canvas scale up by device pixel ratio
  canvas.height = Math.floor(height * devicePixelRatio); // canvas scale up by device pixel ratio

  canvas.style.width = width + "px"; // keep
  canvas.style.height = height + "px"; // style scale down by same scale value
  ctx.mozImageSmoothingEnabled = false;
  ctx.imageSmoothingEnabled = false;
}
